import React from "react";

import PropTypes from "prop-types";

type Props<T> = {
  heading?: React.ReactNode;
  items: Array<T>;
};
export function HeaderRow<T>({ items, heading, ...rest }: Props<T>) {
  return (
    <tr {...rest}>
      <th colSpan={items.length + 1}>{heading}</th>
    </tr>
  );
}
HeaderRow.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.any,
  items: PropTypes.array.isRequired,
};
